import { Impuesto } from "./impuesto";

export class RetencionDetalle{
    public constructor(
        public id: String = "",
        public base_imponible: number = 0,
        public codigo: String = "",
        public descripcion: String = "",
        public porcentaje: number = 0,
        public total: number = 0,
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public retencion_id: String = "",
        public impuesto_id: String = "1",
        public usuario_id:String = null,
        public cuenta_contable_id: String = "",

        public impuesto = new Impuesto(),
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/retencion_detalle.ts